'use client'
import { createContext, useContext, useRef } from 'react'
import type { AudioState } from '../components/Scene3D'

const AudioContext = createContext<React.MutableRefObject<AudioState> | null>(null)

export function AudioProvider({ children }: { children: React.ReactNode }) {
  const audioStateRef = useRef<AudioState>({ audio: null, playing: false, fading: false })
  return (
    <AudioContext.Provider value={audioStateRef}>
      {children}
    </AudioContext.Provider>
  )
}

export function useAudioRef() {
  const ctx = useContext(AudioContext)
  if (!ctx) throw new Error('useAudioRef must be used within AudioProvider')
  return ctx
}
